import { DefaultError, useQuery } from '@tanstack/react-query';
import { useResponseHandler } from 'utils/service/responseHandler';
import { apiClient } from 'utils';
import { IArtistLight } from './types';

export const useGetArtistLightList = () => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IArtistLight[], DefaultError>({
    queryKey: ['artist-light-list'],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Artist/LightList`,
      });

      return responseHandler(response, {
        groupName: `useGetArtistLightList`,
      });
    },
  });
};
